import { render, staticRenderFns } from "./idmeRedirect.vue?vue&type=template&id=f3bcede0&scoped=true"
import script from "./idmeRedirect.vue?vue&type=script&lang=js"
export * from "./idmeRedirect.vue?vue&type=script&lang=js"
import style0 from "./idmeRedirect.vue?vue&type=style&index=0&id=f3bcede0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bcede0",
  null
  
)

export default component.exports